"use strict";

import dataLayerService from './datalayer-service.js';

/**
 * Search Tracking Service
 * Pushes data layer events for search UI interactions and search submissions.
 * Used to track which search interface yields the highest conversion.
 */
const searchTrackingService = (() => {
    const EVENTS = {
        HEADER_SEARCH_B_INTERACT: "header_search_b_interact",
        HEADER_SEARCH_B_SEARCH: "header_search_b_search",
        HEADER_SEARCH_A_INTERACT: "header_search_a_interact",
        HEADER_SEARCH_A_SEARCH: "header_search_a_search",
        HOMEPAGE_SEARCH_INTERACT: "homepage_search_interact",
        HOMEPAGE_SEARCH_SEARCH: "homepage_search_search"
    };

    const pushEvent = (eventName) => {
        dataLayerService.pushEvent(eventName, "search_location", eventName);
    };

    const isMiniMenuB = () => !!document.querySelector('[header-megamenu-toggle]');

    const trackHeaderBInteract = () => pushEvent(EVENTS.HEADER_SEARCH_B_INTERACT);
    const trackHeaderBSearch = () => pushEvent(EVENTS.HEADER_SEARCH_B_SEARCH);
    const trackHeaderAInteract = () => pushEvent(EVENTS.HEADER_SEARCH_A_INTERACT);
    const trackHeaderASearch = () => pushEvent(EVENTS.HEADER_SEARCH_A_SEARCH);
    const trackHomepageInteract = () => pushEvent(EVENTS.HOMEPAGE_SEARCH_INTERACT);
    const trackHomepageSearch = () => pushEvent(EVENTS.HOMEPAGE_SEARCH_SEARCH);

    const trackHeaderInteract = () => {
        if (isMiniMenuB()) return trackHeaderBInteract();
        return trackHeaderAInteract();
    };

    const trackHeaderSearch = () => {
        if (isMiniMenuB()) return trackHeaderBSearch();
        return trackHeaderASearch();
    };

    return {
        EVENTS,
        isMiniMenuB,
        trackHeaderBInteract,
        trackHeaderBSearch,
        trackHeaderAInteract,
        trackHeaderASearch,
        trackHomepageInteract,
        trackHomepageSearch,
        trackHeaderInteract,
        trackHeaderSearch
    };
})();

export default searchTrackingService;
